<div class="message-approval-dashboard">
  <!-- Filter row — reads as the second row of the page header band -->
  <div class="stats-bar-compact">
    <div class="stats-row-unified">
      <!-- Page identity: the title lives in the filter row now (one-row header) -->
      <div class="page-title-cluster">
        <span class="page-identity-chip"><i class="fa-solid fa-check-circle"></i></span>
        <h1 class="page-title">Review &amp; Approve</h1>
      </div>

      <!-- Status pills: spelled out, uniform color; active = brand tint -->
      <div class="stat-pills-compact" [class.searching]="isSearchActive">
        <button class="stat-pill-compact all"
                [class.active]="approvalStatusFilter === 'All'"
                (click)="setApprovalStatusFilter('All')"
                title="Show all messages">
          All
        </button>
        <button class="stat-pill-compact escalate"
                [class.active]="approvalStatusFilter === 'Escalated'"
                (click)="setApprovalStatusFilter('Escalated')"
                title="Escalated — requires human attention">
          Escalated
          <span class="count" *ngIf="!isStatsLoading">{{ stats.escalate }}</span>
          <i class="fa-solid fa-spinner fa-spin count" *ngIf="isStatsLoading"></i>
        </button>
        <button class="stat-pill-compact pending"
                [class.active]="approvalStatusFilter === 'Pending'"
                (click)="setApprovalStatusFilter('Pending')"
                title="Pending review">
          Pending
          <span class="count" *ngIf="!isStatsLoading">{{ stats.pending }}</span>
          <i class="fa-solid fa-spinner fa-spin count" *ngIf="isStatsLoading"></i>
        </button>
        <button class="stat-pill-compact approved"
                [class.active]="approvalStatusFilter === 'Approved'"
                (click)="setApprovalStatusFilter('Approved')"
                title="Approved">
          Approved
          <span class="count" *ngIf="!isStatsLoading">{{ stats.approved }}</span>
          <i class="fa-solid fa-spinner fa-spin count" *ngIf="isStatsLoading"></i>
        </button>
        <button class="stat-pill-compact rejected"
                [class.active]="approvalStatusFilter === 'Rejected'"
                (click)="setApprovalStatusFilter('Rejected')"
                title="Dismissed">
          Dismissed
          <span class="count" *ngIf="!isStatsLoading">{{ stats.rejected + stats.notRequired }}</span>
          <i class="fa-solid fa-spinner fa-spin count" *ngIf="isStatsLoading"></i>
        </button>
      </div>

      <div class="stats-spacer"></div>

      <!-- Total Count -->
      <div class="total-count" title="Total messages">
        <i class="fa-solid fa-envelope"></i>
        <span *ngIf="!isStatsLoading">{{ stats.total }}</span>
        <i class="fa-solid fa-spinner fa-spin" *ngIf="isStatsLoading"></i>
      </div>

      <!-- Search -->
      <div class="search-control-compact">
        <i class="fa-solid fa-search"></i>
        <input type="text"
               #searchInput
               [(ngModel)]="searchQuery"
               (ngModelChange)="onSearchChange($event)"
               (keydown.escape)="clearSearch(); searchInput.blur()"
               placeholder="Search words in sender, subject, recipients and message text (from: subject: to:)"
               class="search-input">
        <button class="search-clear" *ngIf="searchQuery" (click)="clearSearch()">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>

      <!-- Compose (Manual Messages, #289): staff-authored new outbound message on this channel.
           Creates a Pending draft via the Create Manual Message action — approving it sends. -->
      @if (selectedChannel) {
        <button class="compose-button" (click)="openComposeDialog()"
                title="Compose a new message from this channel's mailbox">
          <i class="fa-solid fa-pen-to-square"></i>
          Compose
        </button>
      }

      <!-- Filters popover (shared mj-filter-popover from ng-ui-components) -->
      <mj-filter-popover class="filter-dropdown-compact"
                         Label="Filters"
                         Icon="fa-solid fa-sliders"
                         [ActiveCount]="activeFilterCount"
                         [ShowClearAll]="true"
                         (ClearAllRequested)="clearAllFilters()">
        <div class="filter-popover-content">
          <div class="filter-group">
            <label>Generation status</label>
            <mj-dropdown [Data]="generationStatusOptions"
                         [ValuePrimitive]="true"
                         [ngModel]="generationStatusFilter"
                         (ngModelChange)="onGenerationStatusFilterChange($event)">
            </mj-dropdown>
          </div>
          <div class="filter-group">
            <label>Sort by</label>
            <mj-dropdown [Data]="sortOptions"
                         TextField="label"
                         ValueField="value"
                         [ValuePrimitive]="true"
                         [(ngModel)]="sortMode"
                         (ngModelChange)="onSortModeChange()">
            </mj-dropdown>
          </div>
          <div class="filter-group">
            <label>Queue</label>
            <mj-view-toggle [Options]="queueToggleOptions"
                            [ActiveKey]="queueToggleActiveKey"
                            (KeyChange)="onQueueToggle($event)">
            </mj-view-toggle>
          </div>
          <div class="filter-group">
            <label>Internal notes</label>
            <mj-view-toggle [Options]="notesToggleOptions"
                            [ActiveKey]="notesFilter"
                            (KeyChange)="onNotesToggle($event)">
            </mj-view-toggle>
          </div>
          <div class="filter-group" *ngIf="orgTeamMembers.length > 0">
            <label>By person</label>
            <mj-dropdown [Data]="orgTeamMembers"
                         TextField="name"
                         ValueField="contactId"
                         [ValuePrimitive]="true"
                         [DefaultItem]="assigneeDefaultItem"
                         [ngModel]="assigneeFilterContactId"
                         (ngModelChange)="filterByAssignee($event)">
            </mj-dropdown>
          </div>
        </div>
      </mj-filter-popover>

      <!-- Refresh -->
      <button class="refresh-button-compact"
              (click)="Refresh()"
              [disabled]="isLoading"
              title="Refresh">
        <i class="fa-solid fa-refresh" [class.fa-spin]="isLoading"></i>
      </button>
    </div>
  </div>

  <!-- Bulk Actions Bar (shown when items selected) -->
  <div class="bulk-actions-bar" *ngIf="selectedIds.size > 0">
    <div class="bulk-info">
      <input type="checkbox"
             [checked]="selectAllChecked"
             [indeterminate]="selectedIds.size > 0 && selectedIds.size < displayItemCount"
             (change)="toggleSelectAll()">
      <span>{{ selectedIds.size }} selected (pending/escalated only)</span>
    </div>
    <div class="bulk-buttons">
      <button class="bulk-button approve" (click)="bulkApprove()">
        <i class="fa-solid fa-check"></i>
        Approve All
      </button>
      <button class="bulk-button dismiss" (click)="bulkReject()">
        <i class="fa-solid fa-ban"></i>
        Dismiss All
      </button>
      <button class="bulk-button rescore" (click)="bulkRescore()">
        <i class="fa-solid fa-rotate-right"></i>
        Re-evaluate
      </button>
      <button class="bulk-button clear" (click)="clearSelection()">
        <i class="fa-solid fa-xmark"></i>
        Clear
      </button>
    </div>
  </div>

  <!-- State Update Notification -->
  <div class="state-notification"
       [class.visible]="showStateUpdateNotification"
       [class.warning]="approveArmed"
       [attr.role]="approveArmed ? 'alert' : 'status'">
    <i [class]="approveArmed ? 'fa-solid fa-triangle-exclamation' : 'fa-solid fa-check-circle'"></i>
    <span>{{ notificationMessage }}</span>
  </div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="isLoading">
    <div class="loading-spinner">
      <i class="fa-solid fa-spinner fa-spin"></i>
    </div>
    <div class="loading-text">Loading messages...</div>
  </div>

  <!-- Error State -->
  <div class="error-container" *ngIf="errorMessage && !isLoading">
    <i class="fa-solid fa-exclamation-triangle"></i>
    <span>{{ errorMessage }}</span>
    <button class="retry-button" (click)="loadData()">Try Again</button>
  </div>

  <!-- Main Content: Two Panel Layout -->
  <div class="dashboard-content" *ngIf="!isLoading && !errorMessage" [class.has-detail]="selectedMessage || isDetailLoading">
    <!-- Message List Panel -->
    <div class="message-list"
         [class.has-selection]="selectedMessage"
         [class.collapsed]="isPanelCollapsed"
         [style.width.px]="isPanelCollapsed ? 50 : panelWidth">

      <!-- Collapsed State - just show expand button -->
      <div class="collapsed-panel" *ngIf="isPanelCollapsed">
        <button class="expand-button" (click)="togglePanelCollapse()" title="Expand panel">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
        <span class="collapsed-count">{{ displayItemCount }}</span>
      </div>

      <!-- Expanded Panel Content -->
      <ng-container *ngIf="!isPanelCollapsed">
        <div class="list-header">
          <input type="checkbox"
                 [checked]="selectAllChecked"
                 [indeterminate]="selectedIds.size > 0 && selectedIds.size < displayItemCount"
                 (change)="toggleSelectAll()"
                 title="Select all">
          <span class="message-count">{{ displayItemCount }}</span>
          <span class="keyboard-hint">↑↓ • A/R • M</span>
          <button class="collapse-button" (click)="togglePanelCollapse()" title="Collapse panel">
            <i class="fa-solid fa-chevron-left"></i>
          </button>
        </div>

        <!-- Active-search bar: search intentionally spans ALL approval statuses,
             which used to happen silently — this makes it legible. -->
        <div class="active-search-bar" *ngIf="isSearchActive">
          <i class="fa-solid fa-magnifying-glass"></i>
          <span>Searching all statuses<ng-container *ngIf="selectedChannel"> in {{ selectedChannel.Name }}</ng-container></span>
          <button class="active-search-clear" (click)="clearSearch()">Clear</button>
        </div>

        <div class="message-items-container" [class.bulk-mode]="selectedIds.size > 0" (scroll)="onMessageListScroll($event); activeThreadPopoverId = null">
          <div class="empty-state" *ngIf="displayItems.length === 0">
            <i class="fa-solid fa-inbox"></i>
            <p>{{ getEmptyStateMessage() }}</p>
          </div>

          <ng-container *ngFor="let item of displayItems; let i = index; trackBy: trackDisplayItem">

            <!-- ========== Date Group Header ========== -->
            <div class="date-group-header" *ngIf="item.type === 'group'">{{ item.groupLabel }}</div>

            <!-- ========== Thread Group Header ========== -->
            <div class="thread-group-header"
                 *ngIf="item.type === 'thread' && item.thread"
                 [class.expanded]="item.thread.isExpanded"
                 (click)="toggleThread(item.thread)">
              <div class="thread-chevron">
                <i class="fa-solid" [ngClass]="item.thread.isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
              </div>
              <div class="thread-summary">
                <div class="thread-header-row">
                  <span class="thread-participants" [innerHTML]="highlightSearch(item.thread.participants.join(', '))"></span>
                  <span class="thread-date" [title]="formatDate(item.thread.latestTimestamp)">{{ formatListDate(item.thread.latestTimestamp) }}</span>
                </div>
                <div class="thread-subject" [innerHTML]="highlightSearch(item.thread.subject)"></div>
                <div class="thread-meta">
                  <span class="thread-count-badge">
                    <i class="fa-solid fa-layer-group"></i>
                    {{ item.thread.totalCount }} messages
                  </span>
                  <span class="thread-pending-badge" *ngIf="item.thread.pendingCount > 0">
                    {{ item.thread.pendingCount }} pending
                  </span>
                  <span class="thread-escalated-badge" *ngIf="item.thread.escalatedCount > 0">
                    {{ item.thread.escalatedCount }} escalated
                  </span>
                </div>
              </div>
            </div>

            <!-- ========== Thread Child Message ========== -->
            <div class="message-item-wrapper thread-child"
                 *ngIf="item.type === 'message' && item.isThreadChild && item.message"
                 [class.swipe-left]="swipeState[item.message.ID] === 'left'"
                 [class.swipe-right]="swipeState[item.message.ID] === 'right'"
                 [class.swiping]="swipingMessageId === item.message.ID">
              <div class="swipe-action-left" *ngIf="canApprove(item.message)">
                <div class="swipe-action approve">
                  <i class="fa-solid fa-check"></i>
                  <span>Approve</span>
                </div>
              </div>
              <div class="swipe-action-right" *ngIf="canApprove(item.message)">
                <div class="swipe-action dismiss">
                  <i class="fa-solid fa-ban"></i>
                  <span>Dismiss</span>
                </div>
              </div>
              <div class="message-item"
                   [class.selected]="selectedMessage?.ID === item.message.ID"
                   [class.checked]="selectedIds.has(item.message.ID)"
                   [class.needs-action]="canApprove(item.message)"
                   [class.is-escalated]="item.message.ApprovalStatus === 'Escalated'"
                   [class.thread-sibling]="item.message.isThreadSibling"
                   [class.has-match]="searchQuery && containsSearch(item.message.MessageContentPreview)"
                   [style.transform]="getSwipeTransform(item.message.ID)"
                   (click)="selectMessageFromItem(item.message)"
                   (touchstart)="onTouchStart($event, item.message)"
                   (touchmove)="onTouchMove($event, item.message)"
                   (touchend)="onTouchEnd($event, item.message)">
                <div class="message-checkbox" (click)="$event.stopPropagation()">
                  <!-- Only dispositionable rows offer selection (canApprove: Pending/Escalated,
                       never sent) — selection feeds bulk approve/reject, so an already-sent or
                       decided row must not look actionable. Wrapper stays for row alignment. -->
                  @if (canApprove(item.message)) {
                    <input type="checkbox"
                           [checked]="selectedIds.has(item.message.ID)"
                           (change)="toggleMessageSelection(item.message.ID)">
                  }
                </div>
                <div class="message-content">
                  <div class="message-header">
                    <span class="sender" [innerHTML]="highlightSearch(listDisplayName(item.message)) || 'Unknown'"></span>
                    <span class="date" [title]="formatDate(getDisplayTimestamp(item.message))">{{ formatListDate(getDisplayTimestamp(item.message)) }}</span>
                  </div>
                  <div class="message-subject" *ngIf="item.message.Subject" [innerHTML]="highlightSearch(item.message.Subject)">
                  </div>
                  <div class="message-preview" [innerHTML]="highlightSearch(truncateText(item.message.MessageContentPreview, 100))">
                  </div>
                  <div class="message-meta">
                    <span class="match-type-chip" *ngFor="let mt of getMatchTypes(item.message)">
                      <i class="fa-solid fa-magnifying-glass"></i> {{ mt === 'body' ? 'in message body' : mt }}
                    </span>
                    <span class="approval-badge" *ngIf="showApprovalChip(item.message)" [ngClass]="getApprovalStatusClass(item.message.ApprovalStatus)">
                      <i class="fa-solid fa-gavel"></i> {{ item.message.ApprovalStatus }}
                    </span>
                    @if (noteCounts.get(item.message.ID); as noteCount) {
                      <span class="note-count-badge" [title]="noteCount === 1 ? '1 internal note' : noteCount + ' internal notes'">
                        <i class="fa-solid fa-note-sticky"></i> {{ noteCount }}
                      </span>
                    }
                    @if (staffChipLabel(item.message); as chip) {
                      <span class="staff-origin-chip">
                        <i class="fa-solid" [class.fa-pen-to-square]="chip === 'Composed'" [class.fa-reply]="chip === 'Follow-up'"></i>
                        {{ chip }}
                      </span>
                    }
                    <span class="sent-mini-badge" *ngIf="item.message.SentAt">
                      <i class="fa-solid fa-paper-plane"></i> SENT
                    </span>
                    <span class="send-failed-badge" *ngIf="item.message.ErrorType && !item.message.SentAt && isSendError(item.message.ErrorType)" [title]="friendlyErrorTooltip(item.message)">
                      <i class="fa-solid fa-triangle-exclamation"></i> SEND FAILED
                    </span>
                    <span class="send-failed-badge ai-failed-badge" *ngIf="item.message.ErrorType && !isSendError(item.message.ErrorType)" [title]="friendlyErrorTooltip(item.message)">
                      <i class="fa-solid fa-robot"></i> AI FAILED
                    </span>
                    <span class="edited-indicator" *ngIf="item.message.ApprovedReplyContent && item.message.ApprovedReplyContent !== item.message.GeneratedReplyContent">
                      <i class="fa-solid fa-edit"></i>
                    </span>
                    <span class="forced-generation-badge" *ngIf="item.message.ForcedGeneration">
                      <i class="fa-solid fa-hammer"></i> FORCED
                    </span>
                    <span class="assigned-badge" *ngIf="item.message.AssignedToPersonID"
                          [title]="'Assigned to ' + getContactName(item.message.AssignedToPersonID)">
                      <i class="fa-solid fa-user"></i>
                      {{ getContactName(item.message.AssignedToPersonID) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- ========== Bulk Thread Action (after last child) ========== -->
            <!-- approvableCount, not pendingCount: a pending message whose reply is still
                 generating (or has no content) isn't approvable, and offering "Approve N
                 pending" for it approved nothing while toasting success. -->
            <div class="thread-bulk-actions"
                 *ngIf="item.isThreadChild && item.parentThread && isLastThreadChild(item, i) && item.parentThread.approvableCount > 0"
                 (click)="$event.stopPropagation()">
              <button class="thread-bulk-approve"
                      (click)="bulkApproveThread(item.parentThread)">
                <i class="fa-solid fa-check-double"></i>
                Approve {{ item.parentThread.approvableCount }} pending
              </button>
            </div>

            <!-- ========== Standalone Message (no thread or single-message thread) ========== -->
            <div class="message-item-wrapper"
                 *ngIf="item.type === 'message' && !item.isThreadChild && item.message"
                 [class.swipe-left]="swipeState[item.message.ID] === 'left'"
                 [class.swipe-right]="swipeState[item.message.ID] === 'right'"
                 [class.swiping]="swipingMessageId === item.message.ID">
              <div class="swipe-action-left" *ngIf="canApprove(item.message)">
                <div class="swipe-action approve">
                  <i class="fa-solid fa-check"></i>
                  <span>Approve</span>
                </div>
              </div>
              <div class="swipe-action-right" *ngIf="canApprove(item.message)">
                <div class="swipe-action dismiss">
                  <i class="fa-solid fa-ban"></i>
                  <span>Dismiss</span>
                </div>
              </div>
              <div class="message-item"
                   [class.selected]="selectedMessage?.ID === item.message.ID"
                   [class.checked]="selectedIds.has(item.message.ID)"
                   [class.needs-action]="canApprove(item.message)"
                   [class.is-escalated]="item.message.ApprovalStatus === 'Escalated'"
                   [class.thread-sibling]="item.message.isThreadSibling"
                   [class.has-match]="searchQuery && containsSearch(item.message.MessageContentPreview)"
                   [style.transform]="getSwipeTransform(item.message.ID)"
                   (click)="selectMessageFromItem(item.message)"
                   (touchstart)="onTouchStart($event, item.message)"
                   (touchmove)="onTouchMove($event, item.message)"
                   (touchend)="onTouchEnd($event, item.message)">
                <div class="message-checkbox" (click)="$event.stopPropagation()">
                  <!-- Only dispositionable rows offer selection (canApprove: Pending/Escalated,
                       never sent) — selection feeds bulk approve/reject, so an already-sent or
                       decided row must not look actionable. Wrapper stays for row alignment. -->
                  @if (canApprove(item.message)) {
                    <input type="checkbox"
                           [checked]="selectedIds.has(item.message.ID)"
                           (change)="toggleMessageSelection(item.message.ID)">
                  }
                </div>
                <div class="message-content">
                  <div class="message-header">
                    <span class="sender" [innerHTML]="highlightSearch(listDisplayName(item.message)) || 'Unknown'"></span>
                    <span class="date" [title]="formatDate(getDisplayTimestamp(item.message))">{{ formatListDate(getDisplayTimestamp(item.message)) }}</span>
                  </div>
                  <div class="message-subject" *ngIf="item.message.Subject" [innerHTML]="highlightSearch(item.message.Subject)">
                  </div>
                  <div class="message-preview" [innerHTML]="highlightSearch(truncateText(item.message.MessageContentPreview, 100))">
                  </div>
                  <div class="message-meta">
                    <span class="match-type-chip" *ngFor="let mt of getMatchTypes(item.message)">
                      <i class="fa-solid fa-magnifying-glass"></i> {{ mt === 'body' ? 'in message body' : mt }}
                    </span>
                    <span class="approval-badge" *ngIf="showApprovalChip(item.message)" [ngClass]="getApprovalStatusClass(item.message.ApprovalStatus)">
                      <i class="fa-solid fa-gavel"></i> {{ item.message.ApprovalStatus }}
                    </span>
                    @if (noteCounts.get(item.message.ID); as noteCount) {
                      <span class="note-count-badge" [title]="noteCount === 1 ? '1 internal note' : noteCount + ' internal notes'">
                        <i class="fa-solid fa-note-sticky"></i> {{ noteCount }}
                      </span>
                    }
                    @if (staffChipLabel(item.message); as chip) {
                      <span class="staff-origin-chip">
                        <i class="fa-solid" [class.fa-pen-to-square]="chip === 'Composed'" [class.fa-reply]="chip === 'Follow-up'"></i>
                        {{ chip }}
                      </span>
                    }
                    <span class="sent-mini-badge" *ngIf="item.message.SentAt">
                      <i class="fa-solid fa-paper-plane"></i> SENT
                    </span>
                    <span class="send-failed-badge" *ngIf="item.message.ErrorType && !item.message.SentAt && isSendError(item.message.ErrorType)" [title]="friendlyErrorTooltip(item.message)">
                      <i class="fa-solid fa-triangle-exclamation"></i> SEND FAILED
                    </span>
                    <span class="send-failed-badge ai-failed-badge" *ngIf="item.message.ErrorType && !isSendError(item.message.ErrorType)" [title]="friendlyErrorTooltip(item.message)">
                      <i class="fa-solid fa-robot"></i> AI FAILED
                    </span>
                    <span class="edited-indicator" *ngIf="item.message.ApprovedReplyContent && item.message.ApprovedReplyContent !== item.message.GeneratedReplyContent">
                      <i class="fa-solid fa-edit"></i>
                    </span>
                    <span class="forced-generation-badge" *ngIf="item.message.ForcedGeneration">
                      <i class="fa-solid fa-hammer"></i> FORCED
                    </span>
                    <span class="assigned-badge" *ngIf="item.message.AssignedToPersonID"
                          [title]="'Assigned to ' + getContactName(item.message.AssignedToPersonID)">
                      <i class="fa-solid fa-user"></i>
                      {{ getContactName(item.message.AssignedToPersonID) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </ng-container>
        </div>

        <!-- Infinite Scroll Sentinel -->
        <div class="scroll-sentinel-area">
          <div #scrollSentinel class="scroll-sentinel"></div>
          <div class="loading-more" *ngIf="isLoadingMore">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <span>Loading more messages...</span>
          </div>
          <div class="end-of-messages" *ngIf="!hasMore && messages.length > 0 && !isLoading">
            All messages loaded
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Resize Handle -->
    <div class="panel-resize-handle"
         *ngIf="!isPanelCollapsed && (selectedMessage || isDetailLoading)"
         (mousedown)="onResizeStart($event)">
    </div>

    <!-- Message Detail Panel -->
    <div class="message-detail" *ngIf="selectedMessage || isDetailLoading">
      <!-- Mobile Back Button -->
      <button class="mobile-back-button" (click)="deselectMessage()">
        <i class="fa-solid fa-arrow-left"></i>
        Back to messages
      </button>
      <!-- Detail Loading Overlay -->
      <div class="detail-loading-overlay" *ngIf="isDetailLoading">
        <i class="fa-solid fa-spinner fa-spin"></i>
      </div>


      <ng-container *ngIf="selectedMessage">
      <!-- Presence: who else has this message open (advisory only) -->
      @if (presence.otherViewers.length > 0) {
        <div class="izzy-msg-presence-banner">
          <i class="fa-solid fa-eye"></i>
          @if (presence.otherViewers.length === 1) {
            <span>{{ presence.otherViewers[0] }} is also viewing this message.</span>
          } @else {
            <span>{{ presence.otherViewers.length }} others are also viewing this message: {{ presence.otherViewers.join(', ') }}</span>
          }
        </div>
      }
      <div class="detail-header" [attr.data-status]="selectedMessage.ApprovalStatus?.toLowerCase()">
        <!-- Approved state: Status summary bar -->
        <div class="status-summary-bar approved" *ngIf="!isEditMode && selectedMessage.ApprovalStatus === 'Approved'">
          <div class="status-indicator">
            <i class="fa-solid fa-check-circle"></i>
            <span class="status-text">Approved</span>
            <span class="status-meta" *ngIf="selectedMessage.AIAutoApproved">
              <i class="fa-solid fa-bolt"></i> Auto
            </span>
            <span class="status-meta" *ngIf="selectedMessage.AIConfidenceScore !== null && selectedMessage.AIConfidenceScore !== undefined">
              ({{ selectedMessage.AIConfidenceScore }}%)
            </span>
            <span class="status-time" *ngIf="selectedMessage.ApprovedAt">
              <i class="fa-regular fa-clock"></i> {{ formatRelativeTime(selectedMessage.ApprovedAt) }}
            </span>
          </div>
          <div class="status-actions">
            <span class="sent-badge" *ngIf="selectedMessage.SentContent">
              <i class="fa-solid fa-paper-plane"></i> Sent
            </span>
            <span class="send-failed-badge-inline" *ngIf="selectedMessage.ErrorType && !selectedMessage.SentContent && isSendError(selectedMessage.ErrorType)">
              <i class="fa-solid fa-triangle-exclamation"></i> Send Failed
            </span>
            <button class="action-button-small retry-send"
                    *ngIf="selectedMessage.ErrorType && !selectedMessage.SentContent && canRetrySend(selectedMessage)"
                    (click)="retrySendMessage()"
                    [disabled]="isSaving"
                    title="Retry sending this message">
              <i class="fa-solid fa-rotate-right"></i>
              Retry Send
            </button>
            <!-- Shown for failed sends too (not just clean un-sent approvals): Retry Send
                 resends the same payload, so a send that fails on its content — e.g.
                 attachments over the size cap — is only fixable by going back to Pending,
                 where attachments become editable again. reopenForReview() already guards
                 on SentContent alone. -->
            <button class="action-button-small reopen"
                    *ngIf="!selectedMessage.SentContent"
                    (click)="reopenForReview()"
                    title="Re-open this message for review">
              <i class="fa-solid fa-rotate-left"></i>
              Re-open
            </button>
            <!-- Follow up (#289): send another reply on this thread ("actually, one more
                 thing…") — opens the composer thread-locked onto this message. -->
            @if (selectedMessage.ExternalSystemRecordID) {
              <button class="action-button-small follow-up"
                      (click)="openFollowUpDialog()"
                      title="Send another reply in this email thread">
                <i class="fa-solid fa-reply"></i>
                Follow up
              </button>
            }
            <!-- No Escalate here: an Approved message has usually already been sent, and
                 escalating it re-arms approval — a second approve would re-send the reply
                 to the member. Un-sent approvals go through Re-open first (IsEscalatable). -->
          </div>
        </div>

        <!-- Rejected state: Status summary bar -->
        <div class="status-summary-bar rejected" *ngIf="!isEditMode && selectedMessage.ApprovalStatus === 'Rejected'">
          <div class="status-indicator">
            <i class="fa-solid fa-times-circle"></i>
            <span class="status-text">Rejected</span>
            <span class="status-time" *ngIf="selectedMessage.ApprovedAt">
              <i class="fa-regular fa-clock"></i> {{ formatRelativeTime(selectedMessage.ApprovedAt) }}
            </span>
          </div>
          <div class="status-actions">
            <button class="action-button-small reopen"
                    (click)="reopenForReview()"
                    title="Re-open this message for review">
              <i class="fa-solid fa-rotate-left"></i>
              Re-open
            </button>
            <button class="action-button-small escalate"
                    (click)="escalateMessage()"
                    title="Escalate this message for human review">
              <i class="fa-solid fa-exclamation-triangle"></i>
              Escalate
            </button>
          </div>
        </div>

        <!-- Not Required state: Status summary bar -->
        <div class="status-summary-bar not-required" *ngIf="!isEditMode && selectedMessage.ApprovalStatus === 'Not Required'">
          <div class="status-indicator">
            <i class="fa-solid fa-minus-circle"></i>
            <span class="status-text">Not Required</span>
          </div>
          <div class="status-actions">
            <!-- No Follow up here (product call 2026-08-25): follow-up is Approved-only, so the
                 Dismissed bucket (Rejected + Not Required) is uniformly button-less. Manual
                 answers to a declined message go through Re-open. -->
            <button class="action-button-small reopen"
                    (click)="reopenForReview()"
                    title="Re-open this message for review">
              <i class="fa-solid fa-rotate-left"></i>
              Re-open
            </button>
            <button class="action-button-small escalate"
                    (click)="escalateMessage()"
                    title="Escalate this message for human review">
              <i class="fa-solid fa-exclamation-triangle"></i>
              Escalate
            </button>
          </div>
        </div>

        <!-- Escalated state: compact summary — category badge + the first sentence of the
             reason; the full escalation reasoning renders with the draft inside the viewer's card -->
        <div class="status-summary-bar escalate" *ngIf="!isEditMode && selectedMessage.ApprovalStatus === 'Escalated'">
          <div class="status-indicator">
            <i class="fa-solid fa-exclamation-triangle"></i>
            <span class="status-text">Message Escalated</span>
            @if (selectedMessage.SkipCategory) {
              <span class="escalation-category-badge">{{ formatSkipCategory(selectedMessage.SkipCategory) }}</span>
            }
            <span class="status-time" *ngIf="selectedMessage.EscalatedAt">
              <i class="fa-regular fa-clock"></i> {{ formatRelativeTime(selectedMessage.EscalatedAt) }}
            </span>
          </div>
          @if (firstSentence(selectedMessage.SkipReasoning); as reason) {
            <div class="escalation-reason-line" [title]="reason">{{ reason }}</div>
          }
        </div>

        <!-- Edit mode: minimal header indicator (editor has its own buttons) -->
        <div class="edit-mode-actions" *ngIf="isEditMode">
          <div class="edit-mode-indicator">
            <i class="fa-solid fa-edit"></i>
            <span>Editing</span>
          </div>
        </div>

        <!-- Navigation buttons on right -->
        <div class="detail-actions-right">
          <button class="icon-button" (click)="navigatePrevious()" [disabled]="selectedIndex <= 0" title="Previous (K)">
            <i class="fa-solid fa-chevron-up"></i>
          </button>
          <button class="icon-button" (click)="navigateNext()" [disabled]="selectedIndex >= messages.length - 1" title="Next (J)">
            <i class="fa-solid fa-chevron-down"></i>
          </button>
          <button class="icon-button" (click)="deselectMessage()" title="Close (Esc)">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
      </div>

      <div class="detail-content" [class.edit-mode]="isEditMode">
        <!-- Read header: subject + route, with generation state (only when
             abnormal) and the AI confidence ring on the right. Approval
             state lives on the viewer's draft card chip. -->
        <div class="detail-read-header">
          <div class="read-header-main">
            <div class="read-subject" *ngIf="selectedMessage.Subject" [title]="selectedMessage.Subject">{{ selectedMessage.Subject }}</div>
            <div class="read-route">
              <span>{{ selectedMessage.Sender || 'Unknown' }}</span>
              <i class="fa-solid fa-arrow-right-long"></i>
              <span>{{ selectedMessage.Recipient || 'Unknown' }}</span>
            </div>
          </div>
          <div class="read-header-side">
            <span class="status-badge" *ngIf="isAbnormalGeneration(selectedMessage.GenerationStatus)" [ngClass]="getGenerationStatusClass(selectedMessage.GenerationStatus)">
              {{ selectedMessage.GenerationStatus }}
            </span>
            <div class="confidence-ring" *ngIf="selectedMessage.AIConfidenceScore !== null"
                 [ngClass]="getConfidenceScoreClass(selectedMessage.AIConfidenceScore)"
                 [title]="'AI confidence ' + selectedMessage.AIConfidenceScore + '%'">
              <svg viewBox="0 0 36 36" aria-hidden="true">
                <path class="ring-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                <path class="ring-fill" [attr.stroke-dasharray]="selectedMessage.AIConfidenceScore + ', 100'"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
              </svg>
              <span class="ring-label">{{ selectedMessage.AIConfidenceScore }}</span>
            </div>
          </div>
        </div>

        <!-- Reply recipients: who this reply will go to when approved (Pending/Escalated only).
             Outlook-style Reply / Reply All selector; CC is freely editable. The server applies
             suppression (own/monitored mailboxes, noreply, duplicates) and the recipient cap. -->
        <div class="reply-recipients-bar"
             *ngIf="selectedMessage.ApprovalStatus === 'Pending' || selectedMessage.ApprovalStatus === 'Escalated'">
          <div class="recipients-mode" *ngIf="replyAllAvailable">
            <button type="button" class="mode-button" [class.active]="replyMode === 'reply'"
                    (click)="setReplyMode('reply')" title="Reply to the sender only">
              <i class="fa-solid fa-reply"></i> Reply
            </button>
            <button type="button" class="mode-button" [class.active]="replyMode === 'replyAll'"
                    (click)="setReplyMode('replyAll')" title="Reply to everyone on the original email">
              <i class="fa-solid fa-reply-all"></i> Reply All
            </button>
          </div>
          <div class="recipients-fields">
            <div class="recipients-row">
              <label>To:</label>
              <!-- Staff drafts are field-inverted: Sender is the mailbox, Recipient the target -->
              <span class="recipients-to">{{ isStaffDraft(selectedMessage) ? selectedMessage.Recipient : selectedMessage.Sender }}</span>
            </div>
            <div class="recipients-row">
              <label>Cc:</label>
              <input type="text" class="recipients-cc-input" [(ngModel)]="ccInput"
                     (ngModelChange)="rememberCc($event)"
                     placeholder="Add addresses, separated by commas"
                     [attr.aria-label]="'CC recipients'" />
            </div>
            <!-- Outbound attachments: files staff add here are sent with the approved reply.
                 Persisted server-side via the Attach/Remove Reply actions (tenant-scoped,
                 Pending/Escalated only, 25MB/file). Outlook (Microsoft Graph) channels only. -->
            <div class="recipients-row approval-attach-row">
              <label>Files:</label>
              <div class="approval-attach-body">
                @for (att of replyAttachments; track att.ID; let i = $index) {
                  <span class="approval-attach-chip">
                    <button type="button" class="approval-attach-chip-preview" (click)="openReplyAttachment(i)"
                            [attr.aria-label]="'Preview attachment ' + att.Name" [title]="'Preview ' + att.Name">
                      <i class="fa-solid fa-paperclip"></i>
                      <span class="approval-attach-chip-name">{{ att.Name }}</span>
                    </button>
                    <button type="button" class="approval-attach-chip-remove" (click)="removeReplyAttachment(att)"
                            [attr.aria-label]="'Remove attachment ' + att.Name" title="Remove">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </span>
                }
                <button type="button" class="approval-attach-button" (click)="triggerAttachmentPicker(attachFileInput)"
                        [disabled]="isUploadingAttachment" title="Attach a file to this reply (25MB max per file)">
                  <i class="fa-solid" [class.fa-paperclip]="!isUploadingAttachment" [class.fa-spinner]="isUploadingAttachment" [class.fa-spin]="isUploadingAttachment"></i>
                  {{ isUploadingAttachment ? 'Uploading…' : 'Attach' }}
                </button>
                <input type="file" #attachFileInput multiple hidden (change)="onAttachmentFilesSelected(attachFileInput)" />
              </div>
            </div>
            @if (attachmentError) {
              <div class="recipients-row approval-attach-error">
                <label></label>
                <span>{{ attachmentError }}</span>
              </div>
            }
          </div>
        </div>

        <!-- Sent recipients (read-only audit): once approved, the compose bar above goes away and
             nothing showed who the reply actually went to. SentToRecipients/SentCCRecipients are
             what the server delivered AFTER suppression and the cap — the true record, not the
             draft — so this stays accurate even when Cc was trimmed at send time. -->
        <div class="reply-recipients-bar sent-recipients-bar"
             *ngIf="selectedMessage.ApprovalStatus === 'Approved' && (selectedMessage.SentToRecipients || selectedMessage.SentCCRecipients)">
          <div class="recipients-fields">
            <div class="recipients-row" *ngIf="selectedMessage.SentToRecipients">
              <label>To:</label>
              <span class="recipients-to">{{ selectedMessage.SentToRecipients }}</span>
            </div>
            <div class="recipients-row" *ngIf="selectedMessage.SentCCRecipients">
              <label>Cc:</label>
              <span class="recipients-to">{{ selectedMessage.SentCCRecipients }}</span>
            </div>
          </div>
        </div>

        <!-- Message Viewer (read-only sections) - hidden in edit mode -->
        <izzy-message-viewer
          *ngIf="!isEditMode"
          [message]="selectedMessage"
          [isSystemDeveloper]="isSystemDeveloper"
          [isRescoring]="isRescoring"
          [canRescore]="canRescoreMessage()"
          [isReprocessing]="isReprocessing"
          [organizationId]="selectedOrganization?.ID || null"
          (rescoreRequested)="rescoreMessage()"
          (noteAdded)="onNoteAdded($event)">
        </izzy-message-viewer>

        <!-- Edit Mode - WYSIWYG Editor -->
        <div class="edit-section" *ngIf="isEditMode">
          <izzy-message-editor
            [originalContent]="selectedMessage.EditBaselineContent"
            [currentContent]="selectedMessage.ApprovedReplyContent || selectedMessage.GeneratedReplyContent || ''"
            [messageFormat]="getMessageFormat()"
            [assistChannelId]="selectedMessage.ChannelID"
            [assistChannelMessageId]="selectedMessage.ID"
            [assistThreadContext]="selectedMessage.MessageContent"
            (contentChange)="onEditorContentChange($event)"
            (save)="onEditorSave($event)"
            (saveDraft)="onEditorSaveDraft($event)"
            (cancel)="onEditorCancel()"
            (revert)="onEditorRevert()">
          </izzy-message-editor>
        </div>

        <!-- Edit mode: the customer's original email and the internal notes stay reachable
             below the editor (client ask 2026-09-13). The pane scrolls in edit mode — see
             .detail-content.edit-mode in the CSS. The original-message card hides itself for
             staff drafts and forwards, which have no inbound half. -->
        @if (isEditMode) {
          <izzy-message-viewer
            [message]="selectedMessage"
            [editCompanion]="true"
            (noteAdded)="onNoteAdded($event)">
          </izzy-message-viewer>
        }

        </div>

        <!-- Bottom action bar: decisions live at the end of the reading flow.
             Actions moved verbatim from the top header (pending) and the
             escalated summary bar; both sets keep their guards. -->
        <!-- Stays mounted while isSaving: approve flips ApprovalStatus to 'Approved' BEFORE the
             (seconds-long) send runs, and without this the whole bar — including the sending
             signal inside it — unmounts the instant the button is clicked. -->
        <div class="detail-action-bar"
             *ngIf="!isEditMode && (selectedMessage.ApprovalStatus === 'Pending' || selectedMessage.ApprovalStatus === 'Escalated' || isSaving)"
             [class.action-bar-busy]="isSaving || isReprocessing"
             [attr.inert]="isSaving || isReprocessing ? '' : null">
          <!-- Send-in-progress signal (design pick 2026-08-24): an animated strip across the
               bar's top edge + a status line saying what's in flight. The buttons dim behind
               it; the completion toast is unchanged. -->
          @if (isSaving || isReprocessing) {
            <div class="action-bar-progress" aria-hidden="true">
              <div class="action-bar-progress-fill"></div>
            </div>
            <div class="action-bar-status" role="status" aria-live="polite">
              <i class="fa-solid fa-spinner fa-spin"></i>
              <span>{{ savingLabel || 'Working…' }}</span>
            </div>
          }
          <div class="action-bar-set" *ngIf="selectedMessage.ApprovalStatus === 'Pending'">
          <button class="action-button approve"
                  (click)="approveMessage()"
                  [disabled]="!canApproveMessage()"
                  [title]="getApproveDisabledReason()">
            <i [class]="isSaving && savingAction === 'Approved' ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-check'"></i>
            {{ approveLabel() }} @if (!isSaving) { <kbd class="kbd-hint">A</kbd> }
          </button>
          <button class="action-button dismiss"
                  (click)="rejectMessage()"
                  [disabled]="!canRejectMessage()"
                  [title]="getRejectDisabledReason()">
            <i [class]="isSaving && savingAction === 'Rejected' ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-ban'"></i>
            {{ dismissLabel() }} @if (!isSaving) { <kbd class="kbd-hint">R</kbd> }
          </button>
          <button class="action-button edit"
                  (click)="enterEditOrWriteMode()"
                  [disabled]="!canEditMessage()"
                  [title]="getEditDisabledReason()">
            <i class="fa-solid fa-edit"></i>
            Edit <kbd class="kbd-hint">E</kbd>
          </button>
          <button class="action-button reprocess"
                  *ngIf="canReprocessMessage()"
                  (click)="reprocessMessage()"
                  [disabled]="isReprocessing"
                  title="Re-run the AI agent to generate a new reply">
            <i [class]="isReprocessing ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-rotate-right'"></i>
            {{ isReprocessing ? 'Reprocessing...' : 'Reprocess' }}
          </button>
          <button class="action-button escalate"
                  (click)="escalateMessage()"
                  title="Escalate this message for human review">
            <i class="fa-solid fa-exclamation-triangle"></i>
            Escalate
          </button>

          <!-- Assignment: anyone can assign to anybody (no role gate); self-assign fallback when no member list -->
          <ng-container *ngIf="orgTeamMembers.length > 0; else selfAssignOnly">
            <div class="assign-dropdown-container">
              <button class="action-button assign"
                      (click)="isAssignDropdownOpen = !isAssignDropdownOpen"
                      title="Assign message">
                <i class="fa-solid fa-user-plus"></i>
                {{ getAssignedDisplayName() }}
                <i class="fa-solid fa-chevron-down fa-xs"></i>
              </button>
              <div class="assign-dropdown-menu" *ngIf="isAssignDropdownOpen">
                <button *ngFor="let member of orgTeamMembers"
                        class="assign-dropdown-item"
                        [class.active]="selectedMessage.Get('AssignedToPersonID') === member.contactId"
                        (click)="assignToContact(selectedMessage, member.contactId)">
                  {{ member.name }}
                </button>
                <button class="assign-dropdown-item unassign"
                        *ngIf="selectedMessage.Get('AssignedToPersonID')"
                        (click)="unassignMessage()">
                  <i class="fa-solid fa-user-minus"></i> Unassign
                </button>
              </div>
            </div>
          </ng-container>
          <ng-template #selfAssignOnly>
            <button class="action-button assign"
                    *ngIf="!selectedMessage.Get('AssignedToPersonID')"
                    (click)="assignToMe()"
                    title="Assign to me (M)">
              <i class="fa-solid fa-hand"></i> Claim
            </button>
            <button class="action-button unassign"
                    *ngIf="selectedMessage.Get('AssignedToPersonID')"
                    (click)="unassignMessage()"
                    title="Remove assignment">
              <i class="fa-solid fa-user-minus"></i> Unassign
            </button>
          </ng-template>
          </div>
          <div class="action-bar-set" *ngIf="selectedMessage.ApprovalStatus === 'Escalated'">
            <button class="action-button approve"
                    (click)="approveMessage()"
                    [disabled]="!canApproveMessage()"
                    [title]="getApproveDisabledReason()">
              <i [class]="isSaving && savingAction === 'Approved' ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-check'"></i>
              {{ approveLabel() }} @if (!isSaving) { <kbd class="kbd-hint">A</kbd> }
            </button>
            <button class="action-button dismiss"
                    (click)="rejectMessage()"
                    [disabled]="!canRejectMessage()"
                    [title]="getRejectDisabledReason()">
              <i [class]="isSaving && savingAction === 'Rejected' ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-ban'"></i>
              {{ dismissLabel() }} @if (!isSaving) { <kbd class="kbd-hint">R</kbd> }
            </button>
            <button class="action-button edit"
                    (click)="enterEditOrWriteMode()"
                    [disabled]="!canEditMessage()"
                    [title]="getEditDisabledReason()">
              <i class="fa-solid fa-edit"></i>
              Edit <kbd class="kbd-hint">E</kbd>
            </button>
            <button class="action-button reprocess"
                    *ngIf="canReprocessMessage()"
                    (click)="reprocessMessage()"
                    [disabled]="isReprocessing"
                    title="Re-run the AI agent to generate a new reply">
              <i [class]="isReprocessing ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-rotate-right'"></i>
              {{ isReprocessing ? 'Reprocessing...' : 'Reprocess' }}
            </button>
            <!-- Hidden for staff drafts (#289): no inbound body — nothing for the AI to generate
                 from (the entity-level ForceAIGeneration() is a no-op for them anyway). -->
            @if (!isStaffDraft(selectedMessage)) {
              <button class="action-button secondary"
                      (click)="forceAIGeneration()"
                      [disabled]="isReprocessing"
                      title="Force AI to generate a response (will still require manual approval)">
                <i [class]="isReprocessing ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-robot'"></i>
                {{ isReprocessing ? 'Generating...' : 'Force AI Generate' }}
              </button>
            }

            <!-- Assignment: anyone can assign to anybody (no role gate); self-assign fallback when no member list -->
            <ng-container *ngIf="orgTeamMembers.length > 0; else selfAssignEscalated">
              <div class="assign-dropdown-container">
                <button class="action-button assign"
                        (click)="isAssignDropdownOpen = !isAssignDropdownOpen"
                        title="Assign message">
                  <i class="fa-solid fa-user-plus"></i>
                  {{ getAssignedDisplayName() }}
                  <i class="fa-solid fa-chevron-down fa-xs"></i>
                </button>
                <div class="assign-dropdown-menu" *ngIf="isAssignDropdownOpen">
                  <button *ngFor="let member of orgTeamMembers"
                          class="assign-dropdown-item"
                          [class.active]="selectedMessage.Get('AssignedToPersonID') === member.contactId"
                          (click)="assignToContact(selectedMessage, member.contactId)">
                    {{ member.name }}
                  </button>
                  <button class="assign-dropdown-item unassign"
                          *ngIf="selectedMessage.Get('AssignedToPersonID')"
                          (click)="unassignMessage()">
                    <i class="fa-solid fa-user-minus"></i> Unassign
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-template #selfAssignEscalated>
              <button class="action-button assign"
                      *ngIf="!selectedMessage.Get('AssignedToPersonID')"
                      (click)="assignToMe()"
                      title="Assign to me (M)">
                <i class="fa-solid fa-hand"></i> Claim
              </button>
              <button class="action-button unassign"
                      *ngIf="selectedMessage.Get('AssignedToPersonID')"
                      (click)="unassignMessage()"
                      title="Remove assignment">
                <i class="fa-solid fa-user-minus"></i> Unassign
              </button>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Empty Selection State -->
    <div class="empty-selection" *ngIf="!selectedMessage && messages.length > 0">
      <i class="fa-solid fa-hand-pointer"></i>
      <p>Select a message to view details</p>
      <div class="keyboard-shortcuts">
        <p><strong>Keyboard Shortcuts:</strong></p>
        <ul>
          <li><kbd>↑</kbd> / <kbd>K</kbd> - Previous message</li>
          <li><kbd>↓</kbd> / <kbd>J</kbd> - Next message</li>
          <li><kbd>Space</kbd> - Toggle selection</li>
          <li><kbd>A</kbd> - Approve selected</li>
          <li><kbd>R</kbd> - Reject selected</li>
          <li><kbd>E</kbd> - Edit message</li>
          <li><kbd>M</kbd> - Assign to me</li>
          <li><kbd>Enter</kbd> - Expand/collapse thread</li>
          <li><kbd>/</kbd> - Focus search</li>
          <li><kbd>?</kbd> - Show shortcuts</li>
          <li><kbd>Esc</kbd> - Cancel / Clear selection</li>
        </ul>
      </div>
    </div>
  </div>
</div>


<!-- Confirm Dialog -->
<!-- Manual Messages (#289): compose / follow-up dialog. Creates a Pending draft via the
     Create Manual Message action; nothing sends until the draft is approved. Attachments are
     added AFTER creation via the draft's Files row (the attach actions need a message ID). -->
@if (showComposeDialog) {
  <div class="manual-compose-overlay" (click)="closeComposeDialog()">
    <div class="manual-compose-dialog" (click)="$event.stopPropagation()">
      <div class="manual-compose-header">
        <i class="fa-solid" [class.fa-pen-to-square]="composeMode === 'new'" [class.fa-reply]="composeMode === 'followup'"></i>
        <span>{{ composeMode === 'new' ? 'New message' : 'Follow up' }}</span>
        <button type="button" class="manual-compose-close" (click)="closeComposeDialog()" [disabled]="isComposeSubmitting">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      @if (composeMode === 'followup' && composeParent) {
        <div class="manual-compose-thread-note">
          <i class="fa-solid fa-comment"></i>
          Replies in the same email thread as <strong>{{ composeParent.Subject || '(no subject)' }}</strong>
        </div>
      }

      <div class="manual-compose-field">
        <label>From</label>
        <span class="manual-compose-readonly">{{ selectedChannel?.Name }} — {{ selectedChannel?.ExternalIdentifier }}</span>
      </div>
      <div class="manual-compose-field">
        <label>To</label>
        @if (composeMode === 'new') {
          <input type="text" [(ngModel)]="composeTo" [disabled]="isComposeSubmitting"
                 placeholder="One email address (extra recipients go in CC)" />
        } @else {
          <span class="manual-compose-readonly">{{ composeTo }} <i class="fa-solid fa-lock" title="Follow-ups reply to the original sender"></i></span>
        }
      </div>
      <div class="manual-compose-field">
        <label>CC</label>
        <input type="text" [(ngModel)]="composeCc" [disabled]="isComposeSubmitting"
               placeholder="Optional, comma-separated" />
      </div>
      <div class="manual-compose-field">
        <label>Subject</label>
        @if (composeMode === 'new') {
          <input type="text" [(ngModel)]="composeSubject" [disabled]="isComposeSubmitting" />
        } @else {
          <span class="manual-compose-readonly">{{ composeSubject }} <i class="fa-solid fa-lock" title="Follow-ups keep the thread's subject"></i></span>
        }
      </div>
      <div class="manual-compose-field manual-compose-body-field">
        <label>Body</label>
        <!-- Same rich editor as Review & Approve (compact: no header/footer). Body is HTML;
             the Create Manual Message action passes HTML through. The AI assistant is scoped to
             the selected channel (no message exists yet). -->
        <izzy-message-editor class="manual-compose-editor"
          [compact]="true"
          [currentContent]="composeBodySeed"
          [readOnly]="isComposeSubmitting"
          placeholder="Write the message. You can attach files once the draft is created."
          [assistChannelId]="selectedChannel?.ID || null"
          [assistThreadContext]="composeParent?.MessageContent || null"
          (contentChange)="composeBody = $event.content">
        </izzy-message-editor>
      </div>

      @if (composeError) {
        <div class="manual-compose-error">
          <i class="fa-solid fa-triangle-exclamation"></i> {{ composeError }}
        </div>
      }

      <div class="manual-compose-actions">
        <span class="manual-compose-hint">
          <i class="fa-regular fa-clock"></i>
          Creates a Pending draft — approve it to send
        </span>
        <button type="button" class="manual-compose-cancel" (click)="closeComposeDialog()" [disabled]="isComposeSubmitting">Cancel</button>
        <button type="button" class="manual-compose-submit" (click)="submitCompose()" [disabled]="!canSubmitCompose()">
          <i class="fa-solid" [class.fa-pen-to-square]="!isComposeSubmitting" [class.fa-spinner]="isComposeSubmitting" [class.fa-spin]="isComposeSubmitting"></i>
          {{ isComposeSubmitting ? 'Creating…' : 'Create draft' }}
        </button>
      </div>
    </div>
  </div>
}

<div class="confirm-overlay" *ngIf="confirmDialogVisible" (click)="closeConfirmDialog()">
  <div class="confirm-dialog" (click)="$event.stopPropagation()">
    <div class="confirm-header" [class.danger]="confirmDialogDanger">
      <i class="fa-solid" [ngClass]="confirmDialogDanger ? 'fa-exclamation-triangle' : 'fa-question-circle'"></i>
      <h3>{{ confirmDialogTitle }}</h3>
    </div>
    <div class="confirm-body">
      <p>{{ confirmDialogMessage }}</p>
      <div *ngIf="confirmDialogHasInput" class="confirm-input-group">
        <label>{{ confirmDialogInputLabel }}</label>
        <textarea [(ngModel)]="confirmDialogInputValue"
                  placeholder="Required..."
                  rows="3"></textarea>
      </div>
    </div>
    <div class="confirm-actions">
      <button
        class="confirm-btn-yes"
        [class.danger]="confirmDialogDanger"
        (click)="confirmDialogYes()"
        [disabled]="isSaving || (confirmDialogHasInput && !confirmDialogInputValue.trim())">
        <i class="fa-solid fa-check"></i> {{ confirmDialogButtonText }}
      </button>
      <button class="confirm-btn-no" (click)="closeConfirmDialog()" [disabled]="isSaving">
        <i class="fa-solid fa-times"></i> Cancel
      </button>
    </div>
  </div>
</div>

<!-- Keyboard shortcuts overlay (toggle with ?) -->
<div class="shortcuts-overlay" *ngIf="showShortcutsOverlay" (click)="showShortcutsOverlay = false">
  <div class="shortcuts-panel" (click)="$event.stopPropagation()">
    <div class="shortcuts-panel-header">
      <strong>Keyboard shortcuts</strong>
      <button class="shortcuts-close" (click)="showShortcutsOverlay = false"><i class="fa-solid fa-times"></i></button>
    </div>
    <ul>
      <li><kbd>↑</kbd>/<kbd>K</kbd> Previous · <kbd>↓</kbd>/<kbd>J</kbd> Next</li>
      <li><kbd>A</kbd> Approve · <kbd>R</kbd> Dismiss · <kbd>E</kbd> Edit</li>
      <li><kbd>M</kbd> Assign to me · <kbd>Space</kbd> Select</li>
      <li><kbd>Enter</kbd> Expand thread · <kbd>/</kbd> Search</li>
      <li><kbd>Esc</kbd> Cancel / clear · <kbd>?</kbd> This help</li>
    </ul>
  </div>
</div>

<!-- Attachment preview drawer for staff-attached reply files before sending -->
<app-attachment-drawer
  #replyAttachmentDrawer
  [currentUser]="currentUser"
  [environmentId]="environmentId">
</app-attachment-drawer>
